export default "__VITE_ASSET__xzsHkBsn__"